<template>
  <div
    :class="pulseClasses"
    class="card border border-skeleton border-solid border-l-{10px} shadow-appComponent bg-whiteOverride rounded-md cursor-default select-none overflow-hidden mb-{25px}"
    aria-hidden="true"
    data-test="container">
    <div class="flex flex-col">
      <div class="flex flex-row p-{25px} sm:p-none">
        <div class="hidden md:block pt-{25px} pb-{25px} pl-{25px}">
          <div class="rounded-md w-cardThumbnailW h-cardThumbnailH bg-skeleton"></div>
        </div>
        <div class="flex-grow sm:p-{25px}">
          <div class="flex flex-row sm:flex-col">
            <div class="flex-grow flex flex-col pr-{25px} sm:pr-none">
              <div class="text-22">
                <TextSkeleton :characters="30" />
              </div>
              <div class="text-12 mt-sm">
                <TextSkeleton :characters="20" />
              </div>
            </div>
            <div class="flex flex-col flex-wrap sm:flex-row sm:mt-{25px} sm:ml-{-5px}">
              <ButtonSkeleton
                size="small"
                :characters="12"
                class="card-button"
              />
              <ButtonSkeleton
                size="small"
                :characters="8"
                class="card-button"
              />
              <ButtonSkeleton
                size="small"
                :characters="18"
                class="card-button"
              />
            </div>
          </div>
        </div>
        <div class="w-{230px} 2xl:w-{300px} p-{25px} hidden sm:block md:hidden md:block border-1 border-border border-solid border-t-0 border-r-0 border-b-0">
          <PillSkeleton />
        </div>
      </div>
      <div class="bg-offWhite py-base px-{25px} sm:hidden md:block md:hidden flex flex-row">
        <PillSkeleton />
      </div>
    </div>
  </div>
</template>

<script>
import PillSkeleton from '@/components/library/skeletons/PillSkeleton.vue';
import ButtonSkeleton from '@/components/library/skeletons/ButtonSkeleton.vue';
import TextSkeleton from '@/components/library/skeletons/TextSkeleton.vue';

export default {
  name: 'EnvelopeOverviewSkeleton',
  components: {
    PillSkeleton,
    ButtonSkeleton,
    TextSkeleton,
  },
  props: {
    /**
     * When pulse is true and used within another skeleton
     * component, the pulsing increases.
     *
     * If this component is used on its own somewhere, it won't
     * pulse unless this is true.
     */
    pulse: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    pulseClasses() {
      return {
        'animate-pulse': this.pulse,
      };
    },
  },
};
</script>

<style scoped>
.card-button {
  @apply
    whitespace-nowrap
    m-xs
}
.card-button:first-child {
  @apply
    mt-none
    sm:mt-xs
}
.card-button:last-child {
  @apply
    mb-none
    sm:mb-xs
    sm:mr-none
}
</style>

